
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/uk-admission-day",
      function () {
        return require("private-next-pages/webinar/uk-admission-day.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/uk-admission-day"])
      });
    }
  